export const SUPPORTED_VIDEO_TYPES = [
  "avi",
  "mov",
  "mpg",
  "wmv",
  "flv",
  "webm",
  "mkv",
  "m4v",
  "3gp",
  "3g2",
  "mp4",
  "ogv",
];

export const FILE_EXTENSION_TO_MIME_TYPE = {
  avi: "video/x-msvideo",
  mov: "video/quicktime",
  mpg: "video/mpeg",
  wmv: "video/x-ms-wmv",
  flv: "video/x-flv",
  webm: "video/webm",
  mkv: "video/x-matroska",
  m4v: "video/x-m4v",
  "3gp": "video/3gpp",
  "3g2": "video/3gpp2",
  mp4: "video/mp4",
  ogv: "video/ogg",
};

export const SUPPORTED_VIDEO_MIME_TYPES = SUPPORTED_VIDEO_TYPES.map(
  (ext) => FILE_EXTENSION_TO_MIME_TYPE[ext]
).join(", ");
